module.exports = __webpack_public_path__ + "static/media/glitch-error-404-page-background.17c149f6.png";